// Cihazlar (admin) listesinin saf yardımcıları — arama, tip etiketi, sıralama.
// Bileşenden ayrı tutulur ki test edilebilsin.

import { SORTERS } from "../../components/organisms/ClinicRecordList";
import { TYPE_OPTIONS } from "./constants";

const TYPE_LABELS = TYPE_OPTIONS.reduce((acc, o) => {
  if (o.value) acc[o.value] = o.label;
  return acc;
}, {});

/** Katalogda olmayan tipler "Diğer" (GEN) sayılır. */
export const typeCodeOf = (d) => (TYPE_LABELS[d?.typeCode] ? d.typeCode : "GEN");

/** Sunucu `typeLabel` verirse o, yoksa katalog etiketi. */
export const typeLabelOf = (d) => d?.typeLabel || TYPE_LABELS[typeCodeOf(d)];

/** MAC'te ayraçlar önemsiz: "aabbcc" de "AA:BB:CC" de aynı cihazı bulur. */
const macKey = (v) => String(v || "").toLocaleLowerCase("tr").replace(/[:-]/g, "");

const patientName = (p) => `${p?.name || ""} ${p?.surname || ""}`.trim().toLocaleLowerCase("tr");

/** Tek arama kutusu: seri no, MAC, hasta adı veya e-postası (text küçük harf). */
export function matchesDevice(d, text) {
  const mac = macKey(text);
  return (
    String(d.serialNo || "").toLocaleLowerCase("tr").includes(text) ||
    (mac.length > 0 && macKey(d.mac).includes(mac)) ||
    patientName(d.patient).includes(text) ||
    String(d.patient?.email || "").toLocaleLowerCase("tr").includes(text)
  );
}

const collator = new Intl.Collator("tr", { sensitivity: "base" });

export const DEVICE_SORTERS = {
  serial: (a, b) => collator.compare(String(a.serialNo || ""), String(b.serialNo || "")),
  patient: (a, b) => collator.compare(patientName(a.patient), patientName(b.patient)),
  date: SORTERS.date((d) => d.provisionedAt),
};

export const DEVICE_DEFAULT_DIR = { serial: "asc", patient: "asc", date: "desc" };
